import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Moment from 'moment';
import ChatUserList from '../../components/chatPanel/ChatUserList';
import Conversation from '../chatPanel/Conversation/index';
import ContactList from 'components/chatPanel/ContactList/index';
import SearchBox from 'components/SearchBox/index';
import IntlMessages from 'utils/IntlMessages';
import CustomScrollbars from 'utils/CustomScrollbars';
import HOCSectionLoader from '../HOC/HOCSectionLoader';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { Typography } from '@material-ui/core';
const conversationList = [
    {
        id: 1,
        conversationData: [
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
                sentAt: '3:11:25 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 2,
        conversationData: [
            {
                type: 'sent',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:03:28 PM'
            },
            {
                type: 'received',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:05:47 PM'
            },
            {
                type: 'sent',
                message:
                    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
                sentAt: '3:07:52 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            }
        ]
    },
    {
        id: 3,
        conversationData: [
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
                sentAt: '3:11:25 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            }
        ]
    },
    {
        id: 4,
        conversationData: [
            {
                type: 'sent',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:03:28 PM'
            },
            {
                type: 'received',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:05:47 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
                sentAt: '3:11:25 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 5,
        conversationData: [
            {
                type: 'sent',
                message:
                    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
                sentAt: '3:07:52 PM'
            },
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
                sentAt: '3:11:25 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 6,
        conversationData: [
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
                sentAt: '3:11:25 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 7,
        conversationData: [
            {
                type: 'received',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:05:47 PM'
            },
            {
                type: 'sent',
                message:
                    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
                sentAt: '3:07:52 PM'
            },
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            }
        ]
    },
    {
        id: 8,
        conversationData: [
            {
                type: 'sent',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:03:28 PM'
            },
            {
                type: 'sent',
                message:
                    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
                sentAt: '3:07:52 PM'
            },
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 9,
        conversationData: [
            {
                type: 'received',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:05:47 PM'
            },
            {
                type: 'sent',
                message:
                    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
                sentAt: '3:07:52 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 10,
        conversationData: [
            {
                type: 'sent',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:03:28 PM'
            },
            {
                type: 'received',
                message:
                    'English versions from the 1914 translation by H. Rackham',
                sentAt: '3:05:47 PM'
            },
            {
                type: 'sent',
                message:
                    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
                sentAt: '3:07:52 PM'
            },
            {
                type: 'sent',
                message: 'It is a long established fact',
                sentAt: '3:08:35 PM'
            },
            {
                type: 'received',
                message:
                    'I must explain to you how all this mistaken idea of denouncing ',
                sentAt: '3:10:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
                sentAt: '3:11:25 PM'
            },
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            },
            {
                type: 'received',
                message: 'It is a long established fact',
                sentAt: '3:13:28 PM'
            },
            {
                type: 'sent',
                message:
                    'The standard chunk of Lorem Ipsum used since the 1500s',
                sentAt: '3:15:45 PM'
            }
        ]
    },
    {
        id: 11,
        conversationData: [
            {
                type: 'received',
                message: 'There are many variations of passages of ',
                sentAt: '3:12:36 PM'
            },
            {
                type: 'received',
                message: 'All the Lorem Ipsum generators on the',
                sentAt: '3:12:45 PM'
            },
            {
                type: 'sent',
                message: 'There are many variations of passages of ',
                sentAt: '3:13:04 PM'
            }
        ]
    }
];
const users = [
    {
        id: 1,
        name: 'Alex Dolgove',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'away',
        mood: 'English versions from the 1914 translation by H. Rackham',
        lastMessage:
            'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
        unreadMessage: '',
        lastMessageTime: '20 min ago',
        recent: true
    },
    {
        id: 2,
        name: 'Domnic Brown',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'online',
        mood: 'English versions from the 1914 translation by H. Rackham',
        lastMessage: 'It is a long established fact',
        unreadMessage: '4',
        lastMessageTime: 'Yesterday',
        recent: true
    },
    {
        id: 3,
        name: 'Domnic Harris',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'offline',
        mood: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem',
        lastMessage: 'There are many variations of passages of ',
        unreadMessage: '',
        lastMessageTime: '20/11/17',
        recent: true
    },
    {
        id: 4,
        name: 'Garry Sobars',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'away',
        mood: 'It is a long established fact',
        lastMessage: 'English versions from the 1914 translation by H. Rackham',
        unreadMessage: '3',
        lastMessageTime: 'Yesterday',
        recent: true
    },
    {
        id: 5,
        name: 'Jeson Born',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'away',
        mood: 'I must explain to you how all this mistaken idea of denouncing ',
        lastMessage: 'It is a long established fact',
        unreadMessage: '',
        lastMessageTime: 'Monday',
        recent: true
    },
    {
        id: 6,
        name: 'Jimmy Jo',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'online',
        mood:
            'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
        lastMessage: 'All the Lorem Ipsum generators on the',
        unreadMessage: '',
        lastMessageTime: 'Friday',
        recent: false
    },
    {
        id: 7,
        name: 'John Smith',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'away',
        mood: 'There are many variations of passages of ',
        lastMessage:
            'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested',
        unreadMessage: '',
        lastMessageTime: 'Tuesday',
        recent: true
    },
    {
        id: 8,
        name: 'Kadir M',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'online',
        mood: 'All the Lorem Ipsum generators on the',
        lastMessage:
            'I must explain to you how all this mistaken idea of denouncing ',
        unreadMessage: '5',
        lastMessageTime: 'Monday',
        recent: true
    },
    {
        id: 9,
        name: 'Jimmy Jon',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'offline',
        mood: 'There are many variations of passages of ',
        lastMessage: 'There are many variations of passages of ',
        unreadMessage: '',
        lastMessageTime: '30 Min ago',
        recent: true
    },
    {
        id: 10,
        name: 'Stella Johnson',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'offline',
        mood: 'It is a long established fact',
        lastMessage: 'English versions from the 1914 translation by H. Rackham',
        unreadMessage: '',
        lastMessageTime: 'Yesterday',
        recent: true
    },
    {
        id: 11,
        name: 'Steve Smith',
        thumb: 'http://via.placeholder.com/50x50',
        status: 'online',
        mood: 'The standard chunk of Lorem Ipsum used since the 1500s',
        lastMessage: 'The standard chunk of Lorem Ipsum used since the 1500s',
        unreadMessage: '2',
        lastMessageTime: 'Monday',
        recent: true
    }
];

class ChatPanel extends Component {
    constructor() {
        super();
        this.state = {
            loader: false,
            userNotFound: 'No user found',
            drawerState: false,
            selectedSectionId: '',
            selectedTabIndex: 0,
            userState: 1,
            searchChatUser: '',
            contactList: users.filter(user => !user.recent),
            selectedUser: null,
            message: '',
            chatUsers: [],
            conversationList: conversationList,
            conversation: null,
            data: [],
            leftLoader: true,
            errorShow: '',
            noResponse: false,
            conversationData: [],
            detailChat: '',
            size: 100
        };
    }

    getDetailData = selectedUser => {
        this.props.getInboxDetailsAction({
            topTime: this.props.inboxDetails.topTime,
            messageroom: selectedUser.messageroom,
            size: this.state.size,
            type: true
        });
    };

    onDetailDone = (success, data) => {
        if (success) {
            this.setState({
                conversationData: data.data.chats,
                detailChat: data.data
            });
        } else {
            NotificationManager.error(data.message, 'Error');
        }
    };
    componentDidMount() {
        this.getData();
    }
    componentWillUnmount() {
        this.props.removeInboxList();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.inboxList.length != this.props.inboxList.length) {
            this.setState({
                chatUsers: this.props.inboxList,
                conversationData: this.props.inboxDetails.chats,
                detailChat: this.props.inboxDetails
            });
        }

        if (
            prevProps.inboxDetails.chats.length !=
            this.props.inboxDetails.chats.length
        ) {
            this.setState({
                conversationData: this.props.inboxDetails.chats,
                detailChat: this.props.inboxDetails
            });
        }
    }

    getData = () => {
        this.props.getInboxListAction();
    };

    // onDone = (success, data) => {
    //     this.setState({ leftLoader: false });
    //     if (success) {
    //         this.setState({ chatUsers: data.data });
    //     } else {
    //         this.setState({ errorShow: data.message, noResponse: true });
    //     }
    // };

    filterContact = userName => {
        if (userName === '') {
            return users.filter(user => !user.recent);
        }
        return users.filter(
            user =>
                !user.recent &&
                user.name.toLowerCase().indexOf(userName.toLowerCase()) > -1
        );
    };
    filterUsers = userName => {
        if (userName === '') {
            return users.filter(user => user.recent);
        }
        return users.filter(
            user =>
                user.recent &&
                user.name.toLowerCase().indexOf(userName.toLowerCase()) > -1
        );
    };
    Communication = () => {
        const intl = this.props;
        const { message, selectedUser, conversationData } = this.state;

        return (
            <div className="chat-main">
                <div className="chat-main-header">
                    <IconButton
                        className="d-block d-xl-none chat-btn"
                        aria-label="Menu"
                        onClick={this.onToggleDrawer.bind(this)}
                    >
                        <i className="zmdi zmdi-comment-text" />
                    </IconButton>
                    <div className="chat-main-header-info">
                        <div className="chat-avatar mr-2">
                            <div className="chat-avatar-mode">
                                <img
                                    src={selectedUser.thumb}
                                    className="rounded-circle size-60"
                                    alt=""
                                />

                                <span
                                    className={`chat-mode ${selectedUser.status}`}
                                />
                            </div>
                        </div>

                        <div className="chat-contact-name">
                            {selectedUser.name}
                        </div>
                    </div>
                </div>

                <CustomScrollbars
                    className="chat-list-scroll scrollbar"
                    style={{
                        height:
                            this.props.width >= 1200
                                ? 'calc(100vh - 300px)'
                                : 'calc(100vh - 255px)'
                    }}
                >
                    <Conversation
                        userData={this.props.userData}
                        conversationData={conversationData}
                        selectedUser={selectedUser}
                        messageroom={this.state.messageroom}
                    />
                </CustomScrollbars>

                <div className="chat-main-footer">
                    <div
                        className="d-flex flex-row align-items-center"
                        style={{ maxHeight: 51 }}
                    >
                        <div className="col-md-12">
                            <textarea
                                id="required"
                                className="border-0 form-control chat-textarea"
                                onKeyUp={this._handleKeyPress.bind(this)}
                                onChange={this.updateMessageValue.bind(this)}
                                value={message}
                                placeholder="Type and hit enter to send message"
                            />
                        </div>
                        <div className="chat-sent">
                            <IconButton
                                onClick={this.submitComment.bind(this)}
                                aria-label="Send message"
                            >
                                <i className="zmdi  zmdi-mail-send" />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    AppUsersInfo = () => {
        return (
            <div className="chat-sidenav-main">
                <div className="bg-grey lighten-5 chat-sidenav-header">
                    <div className="chat-user-hd mb-0">
                        <IconButton
                            className="back-to-chats-button size-30"
                            aria-label="back button"
                            onClick={() => {
                                this.setState({
                                    userState: 1
                                });
                            }}
                        >
                            <i className="zmdi zmdi-arrow-back" />
                        </IconButton>
                    </div>
                    <div className="chat-user chat-user-center">
                        <div className="chat-avatar mx-auto">
                            <img
                                src="http://via.placeholder.com/50x50"
                                className="avatar avatar-shadow rounded-circle size-60 huge"
                                alt="John Doe"
                            />
                        </div>

                        <div className="user-name h4 my-2">Robert Johnson</div>
                    </div>
                </div>
                <div className="chat-sidenav-content">
                    <CustomScrollbars
                        className="chat-sidenav-scroll scrollbar"
                        style={{
                            height:
                                this.props.width >= 1200
                                    ? 'calc(100vh - 328px)'
                                    : 'calc(100vh - 162px)'
                        }}
                    >
                        <form className="p-4">
                            <div className="form-group mt-4">
                                <label>Mood</label>
                                <Input
                                    fullWidth
                                    id="exampleTextarea"
                                    multiline
                                    rows={3}
                                    onKeyUp={this._handleKeyPress.bind(this)}
                                    onChange={this.updateMessageValue.bind(
                                        this
                                    )}
                                    defaultValue="it's a status....not your diary..."
                                    placeholder="Status"
                                    margin="none"
                                />
                            </div>
                        </form>
                    </CustomScrollbars>
                </div>
            </div>
        );
    };

    ChatUsers = () => {
        return (
            <div className="col-md-12">
                <CustomScrollbars
                    className="chat-sidenav-scroll scrollbar"
                    style={{
                        height:
                            this.props.width >= 1200
                                ? 'calc(100vh - 328px)'
                                : 'calc(100vh - 202px)'
                    }}
                >
                    {this.props.inboxList.length === 0 ? (
                        <div className="p-5" style={{ color: '#000000' }}>
                            No Chat Found
                        </div>
                    ) : (
                        <ChatUserList
                            userData={this.props.userData}
                            chatUsers={this.state.chatUsers}
                            selectedSectionId={this.state.selectedSectionId}
                            onSelectUser={this.onSelectUser.bind(this)}
                        />
                    )}
                </CustomScrollbars>
            </div>
        );
    };
    _handleKeyPress = e => {
        if (e.key === 'Enter') {
            this.submitComment();
        }
    };

    handleChange = (event, value) => {
        this.setState({ selectedTabIndex: value });
    };

    handleChangeIndex = index => {
        this.setState({ selectedTabIndex: index });
    };
    onSelectUser = user => {
        this.setState({
            selectedSectionId: user.id,
            drawerState: this.props.drawerState,
            selectedUser: user,
            conversation: this.state.chatUsers.find(
                data => data.id === user.id
            ),
            messageroom: user.messageroom
        });
        this.getDetailData(user);
    };
    showCommunication = userData => {
        return (
            <div className="chat-box">
                <div className="chat-box-main">
                    {this.state.selectedUser === null ? (
                        <div>
                            <i className="zmdi zmdi-comment s-128 text-muted" />
                            <h3 className="text-muted">Select User to Chat</h3>
                        </div>
                    ) : (
                        this.Communication()
                    )}
                </div>
            </div>
        );
    };

    submitComment() {
        this.props.sendMessageAction({
            text: this.state.message,
            messageroom: this.state.detailChat.messageroom,
            toId: (this.state.detailChat.provider_id === this.props.userData.id) ? this.state.detailChat.customer._id : this.state.detailChat.provider_id
        });
        if (this.state.message !== '') {
            this.setState({ message: '' });
            //     const updatedConversation = this.state.conversationData.concat({
            //         text: this.state.message,
            //         created_at: Moment(new Date()).valueOf()
            //     });
            //     this.setState({
            //         conversation: {
            //             ...this.state.conversation,
            //             conversationData: updatedConversation
            //         },
            //         message: '',
            //         conversationList: this.state.conversationList.map(
            //             conversationData => {
            //                 if (
            //                     conversationData.id === this.state.conversation.id
            //                 ) {
            //                     return {
            //                         ...this.state.conversation,
            //                         conversationData: updatedConversation
            //                     };
            //                 } else {
            //                     return conversationData;
            //                 }
            //             }
            //         )
            //     });
        }
    }

    updateMessageValue(evt) {
        this.setState({
            message: evt.target.value
        });
    }

    updateSearchChatUser(evt) {
        this.setState({
            searchChatUser: evt.target.value,
            contactList: this.filterContact(evt.target.value),
            chatUsers: this.filterUsers(evt.target.value)
        });
    }

    onToggleDrawer() {
        this.setState({
            drawerState: !this.state.drawerState
        });
    }

    render() {
        const {
            loader,
            userState,
            drawerState,
            selectedUser,
            chatUsers,
            conservationData
        } = this.state;
        return (
            <div className="app-wrapper app-wrapper-module">
                <HOCSectionLoader
                    loading={this.props.inboxListLoader}
                    errorShow={this.state.errorShow}
                    noResponse={this.state.noResponse}
                >
                    <div className="app-module chat-module animated slideInUpTiny animation-duration-3">
                        <div className="tz-2-com tz-2-main">
                            <h4 className="inbox-heading">Inbox</h4>
                        </div>
                        <div className="chat-module-box pt-4">
                            <div className="col-md-12">
                                <div className="row align-items-center">
                                    <div className="col-md-5">
                                        <div className="d-block d-xl-none">
                                            <Drawer
                                                open={drawerState}
                                                onClose={this.onToggleDrawer.bind(
                                                    this
                                                )}
                                            >
                                                {this.ChatUsers()}
                                            </Drawer>
                                        </div>

                                        <div className="chat-sidenav d-none d-xl-flex">
                                            {this.ChatUsers()}
                                        </div>
                                    </div>
                                    <div className="col-md-7 text-center">
                                        <HOCSectionLoader
                                            loading={
                                                this.props.inboxDetailLoader
                                            }
                                            errorShow={this.state.errorShow}
                                            noResponse={this.state.noResponse}
                                        >
                                            {this.showCommunication(
                                                this.props.userData
                                            )}
                                        </HOCSectionLoader>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </HOCSectionLoader>
            </div>
        );
    }
}
const mapStateToProps = ({ inbox }) => {
    return {
        inboxList: inbox.inboxList,
        inboxDetails: inbox.inboxDetails,
        inboxDetailLoader: inbox.inboxDetailLoader,
        inboxListLoader: inbox.inboxListLoader
    };
};
export default connect(
    mapStateToProps,
    actions
)(ChatPanel);



// WEBPACK FOOTER //
// ./src/components/Customer/ChatPanel.jsx